import { useState, useSyncExternalStore } from 'react';
import { useAlertSource } from '../alerts/AlertsProvider';
import { CollectionSummary } from '@qkindex/contracts';
import { inventoryMutations } from '../../services/inventoryMutationCoordinator';

/** Shared recovery remains available after a dialog closes or a workspace remounts. */
export function InventoryMutationFeedback({
  userId,
  collections,
}: {
  userId: string;
  collections: CollectionSummary[];
}) {
  const pending = useSyncExternalStore(
    inventoryMutations.subscribe,
    inventoryMutations.getSnapshot,
  );
  const [retrying, setRetrying] = useState<string>();
  useAlertSource(
    userId,
    'inventory-mutations',
    pending
      .filter(
        (entry) =>
          entry.userId === userId &&
          entry.uncertain &&
          entry.retry &&
          entry.scopes.every((scope) =>
            collections.some(
              (collection) =>
                collection.collectionId === scope.collectionId &&
                collection.role !== 'viewer',
            ),
          ),
      )
      .map((entry) => ({
        id: entry.id,
        title: entry.label,
        severity: 'warning',
        message:
          'Awaiting confirmation. Retry the original request before making conflicting changes.',
        action: {
          label: 'Retry',
          disabled: entry.busy || retrying === entry.id,
          run: async () => {
            setRetrying(entry.id);
            try {
              await entry.retry!();
            } finally {
              setRetrying(undefined);
            }
          },
        },
      })),
  );
  return null;
}
